<div class="container-fluid">

  <!-- Formulaire de configuration -->
  <div class="row mt-2" *ngIf="!loading">
    <div class="col-12">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title">
              <i class="fas fa-sliders-h me-2"></i>
              Configuration des Types de Logements
            </h5>
            <p class="card-text text-muted">
              Définissez le taux d'intérêt et la durée en mois pour chaque type de logement de ce programme.
            </p>
          </div>

          <div class="card-body">
            <div *ngIf="homeTypes.length === 0" class="alert alert-warning">
              <i class="fas fa-exclamation-triangle me-2"></i>
              Aucun type de logement trouvé pour cette promotion.
            </div>

            <div *ngIf="homeTypes.length > 0" formArrayName="options">
              <!-- En-tête du tableau -->
              <div class="table-responsive">
                <table class="table table-bordered table-hover">
                  <thead class="thead-dark">
                    <tr>
                      <th width="40%">Type de Logement</th>
                      <th width="25%">Taux (%)</th>
                      <th width="25%">Durée (mois)</th>
                      <th width="10%">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let option of optionsFormArray.controls; let i = index" [formGroupName]="i">

                      <!-- Type de logement -->
                      <td>
                        <div class="d-flex align-items-center">
                          <i class="fas fa-home text-primary me-2"></i>
                          <div>
                            <strong>{{ getOptionControl(i, 'libelle')?.value }}</strong>
                            <input type="hidden" formControlName="uuid">
                            <input type="hidden" formControlName="type">
                            <input type="hidden" formControlName="libelle">
                          </div>
                        </div>
                      </td>

                      <!-- Taux -->
                      <td>
                        <div class="input-group">
                          <input type="number" class="form-control" formControlName="taux"
                            [class.is-invalid]="hasError(i, 'taux')"
                            [class.is-valid]="!hasError(i, 'taux') && getOptionControl(i, 'taux')?.value > 0"
                            placeholder="0.00" min="0" max="100" step="0.01">
                          <div class="input-group-append">
                            <span class="input-group-text">%</span>
                          </div>
                          <div class="invalid-feedback" *ngIf="hasError(i, 'taux')">
                            {{ getErrorMessage(i, 'taux') }}
                          </div>
                        </div>
                      </td>

                      <!-- Durée en mois -->
                      <td>
                        <div class="input-group">
                          <input type="number" class="form-control" formControlName="mois"
                            [class.is-invalid]="hasError(i, 'mois')"
                            [class.is-valid]="!hasError(i, 'mois') && getOptionControl(i, 'mois')?.value > 0"
                            placeholder="12" min="1" max="1000">
                          <div class="input-group-append">
                            <span class="input-group-text">mois</span>
                          </div>
                          <div class="invalid-feedback" *ngIf="hasError(i, 'mois')">
                            {{ getErrorMessage(i, 'mois') }}
                          </div>
                        </div>
                      </td>

                      <!-- Status -->
                      <td class="text-center">
                        <span class="badge badge-success"
                          *ngIf="getOptionControl(i, 'taux')?.value > 0 && getOptionControl(i, 'mois')?.value > 0">
                          <i class="fas fa-check"></i> Configuré
                        </span>
                        <span class="badge badge-secondary"
                          *ngIf="getOptionControl(i, 'taux')?.value <= 0 || getOptionControl(i, 'mois')?.value <= 0">
                          <i class="fas fa-clock"></i> En attente
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Aide contextuelle -->
              <div class="mt-3">
                <div class="row">
                  <div class="col-md-6">
                    <div class="alert alert-info">
                      <i class="fas fa-info-circle me-2"></i>
                      <strong>Taux d'intérêt :</strong> Pourcentage appliqué au montant du logement.
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="alert alert-info">
                      <i class="fas fa-calendar-alt me-2"></i>
                      <strong>Durée :</strong> Nombre de mois pour le remboursement (1-1000 mois).
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Actions -->
          <div class="card-footer">
            <div class="d-flex justify-content-between">
              <button type="button" class="btn btn-warning" (click)="resetForm()" [disabled]="loading">
                <i class="fas fa-undo me-1"></i>
                Réinitialiser
              </button>

              <button type="submit" class="btn btn-success" [disabled]="form.invalid || loading">
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                <i *ngIf="!loading" class="fas fa-save me-1"></i>
                {{ loading ? 'Enregistrement...' : 'Enregistrer la Configuration' }}
              </button>

              <button (click)="modal.close('ferme')" type="button" class="btn btn-secondary text-left" data-dismiss="modal">
                Fermer <i class="feather icon-x-circle"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>